import { put, takeLatest } from "redux-saga/effects";
import { IMPERSONATION_USER_LOGIN, IMPERSONATION_USER_LOGIN_FAILED, IMPERSONATION_USER_LOGIN_INIT, IMPERSONATION_USER_LOGIN_SUCCESS } from "./constants";
import {
  // getUtil,
  postUtil,
  // setBearerToken,
  setDefaultHeader,
  // setSessionDefaultHeader,
} from "../../../services/axiosClient";
import { 
  API, 
  setSessionStorageItem, 
  // setStorageItem 
} from "../../../utils/Constant";
import jwtDecode from "jwt-decode";




const changeToBoolean = (value) => {
  return value === "true" ? true : false;
};
export function* ImpersonationLoginCall({payload , onSuccess}) {
  yield put({ type: IMPERSONATION_USER_LOGIN_INIT });
  try {
    const res = yield postUtil(`${API.AdminLogin}?token=${payload}`);
    if (res?.status === 200) {
      const { data } = res;
      const user = jwtDecode(data.result.accessToken);
      let { IsTwoFactorEnable, PhoneVerified, Signed } = user;
      IsTwoFactorEnable = changeToBoolean(IsTwoFactorEnable);
      PhoneVerified = changeToBoolean(PhoneVerified);
      Signed = changeToBoolean(Signed);
      if (user.PhoneVerified === "false") {
        yield put({
          type: IMPERSONATION_USER_LOGIN_SUCCESS,
          isPhoneVerified: false,
          isTwoFactorEnable: false,
          token: data.result.accessToken,
          userId: data.result.userId,
          
        });
        onSuccess();
      } else if (user.IsTwoFactorEnable === "true") {
        yield put({
          type: IMPERSONATION_USER_LOGIN_SUCCESS,
          isTwoFactorEnable: true,
          isPhoneVerified: true,
          token: data.result.accessToken,
          userId: data.result.userId,
        });
        onSuccess();
      } else {
        sessionStorage.setItem("userId", data.result.userId);
        setSessionStorageItem(sessionStorage, "token", data.result.accessToken, () => {
          setDefaultHeader();
          onSuccess();
        });
      }
    } else {
      yield put({ type: IMPERSONATION_USER_LOGIN_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* Impersonationlogin() {
  yield takeLatest(IMPERSONATION_USER_LOGIN, ImpersonationLoginCall);
}
